import { render } from "./AnnotationBox.vue?vue&type=template&id=69dfc9d5"
import script from "./AnnotationBox.vue?vue&type=script&lang=js"
export * from "./AnnotationBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__